import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

import Menu from "../../Components/Menu";

import Section1_Header from "../S1_Header";
import Section2_About from "../S2_Features";
import Section3_Tokenomics from "../S3_Arbreflection";
import S6_Tokenomics from "../S4_Tokenomics";
import S7_Roadmap from "../S5_Roadmap";
import Section8_Team from "../S6_Team";
import Section9_Team from "../Ecosystem";

import Section9_Footer from "../S7_Footer";

import { PageWrapper } from "../../Styles/style";

import Videostars from "../../../assets/images/starsbg.mp4"
import up from "../../../assets/images/footerimg.png"
import styled from "@emotion/styled";

const VideoBG = styled.video`
object-fit: cover;
position: fixed;
width: 100%;
height: 200VH;
`
const Wrapper = styled.div`
position: RELATIVE;
`
const SectionSubWrapper = styled.div`
background-image: url(${up});
z-index: 1;
background-size: cover;
background-repeat: no-repeat;
`
const MainPage = (props) => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <>

      <PageWrapper style={{overflow:'hidden'}}>
        <VideoBG autoPlay muted loop >
          <source src={Videostars} />
        </VideoBG>
        <Wrapper>
          <Menu/>
          <Section1_Header />
          <Section9_Team />
          <Section2_About />
          <Section3_Tokenomics />
          <Section8_Team />
          <S7_Roadmap />
          {/* <SectionSubWrapper> */}
          <S6_Tokenomics />
            
          {/* </SectionSubWrapper> */}
          <Section9_Footer />
        </Wrapper>
      </PageWrapper>
    </>
  );
};

export default MainPage;
